import { PropTypes } from 'prop-types';
import AccionaIcon from '../../../../../../../components/AccionaIcon';
import { useIntl } from 'react-intl';

const AccionaTableDeliveryButton = ({
  viewAction,
  camViewAction,
  camFileName,
  thereIsScannedDocket,
}) => {
  const intl = useIntl();
  return (
    <>
      <tr>
        <td
          key="labelIconButton01"
          colSpan="6"
          style={{ backgroundColor: '#e6e6e6', textAlign: 'center' }}
        >
          <label style={{ fontSize: '17px' }}>
            {intl.formatMessage({ id: 'deliveryPhoto' })}
          </label>
        </td>
        <td
          key="labelIconButton02"
          colSpan="6"
          style={{
            backgroundColor: '#e6e6e6',
            textAlign: 'center',
            fontSize: '17px',
            fontWeight: 'bold',
          }}
        >
          <label style={{ fontSize: '17px' }}>
            {intl.formatMessage({ id: 'scannedDelivery' })}
          </label>
        </td>
      </tr>
      <tr>
        <td
          key="iconButton01"
          colSpan="6"
          style={{ textAlign: 'center', height: '75px' }}
        >
          <AccionaIcon
            id="icon-delivery"
            className="btn btn-red"
            disabled={camFileName ? false : true}
            onClick={() => camViewAction()}
            classIcon="icon fas fa-camera"
            style={{ width: '80px', height: '50px' }}
            styleIcon={{ transform: 'scale(1.5)' }}
          />
        </td>
        <td
          key="iconButton02"
          colSpan="6"
          style={{ textAlign: 'center', height: '75px' }}
        >
          <AccionaIcon
            id="icon-scanned"
            className="btn btn-red"
            disabled={thereIsScannedDocket}
            onClick={() => viewAction()}
            classIcon="icon fas fa-file-invoice"
            style={{ width: '80px', height: '50px' }}
            styleIcon={{ transform: 'scale(1.5)' }}
          />
        </td>
      </tr>
    </>
  );
};

AccionaTableDeliveryButton.propTypes = {
  viewAction: PropTypes.func.isRequired,
  camViewAction: PropTypes.func.isRequired,
  camFileName: PropTypes.string,
  thereIsScannedDocket: PropTypes.bool,
};

AccionaTableDeliveryButton.defaultProps = {
  camFileName: null,
  thereIsScannedDocket: false,
};

export default AccionaTableDeliveryButton;
